export default "__VITE_ASSET__Bkpk0778__"